





















import { Vue } from 'vue-property-decorator';
import { ObjectHelper, MStorePopupHelper } from '@/mixins';
import { DocumentsToStore } from '@/types';
import { Components } from '@/customer';

export default Vue.extend({
  name: 'MStorePopup',
  mixins: [ObjectHelper, MStorePopupHelper],
  computed: {
    showHeader(this: any) {
      return !this.isNullOrEmpty(this.title);
    }
  },
  methods: {
    getComponentSpecificBindings(this: any) {
      switch (this.componentName) {
        case 'ForwardOrderOrFreeRelease':
          return {
            storeNamespace: this.$route.name === DocumentsToStore.DocumentsToStore.name ? 'documentToStoreStore' : 'editReferencesStore'
          };
        default:
          return {};
      }
    }
  },
  components: {
    Feedback: () => import('./Feedback.vue'),
    WorkflowKanbanPopupFields: () => import('../workflow/kanban/WorkflowKanbanPopupFields.vue'),
    ExampleCustomIndexingLookup: () => import('../documentToStore/testComponents/ExampleCustomIndexingLookup.vue'),
    ForwardOrderOrFreeRelease: () => import('../documentToStore/automotive/ForwardOrderOrFreeRelease.vue'),
    ...Components.CustomIndexingLookup
  }
});
